import { CallHistoryMethodAction, push } from 'connected-react-router';
import { isNetquestClient, isPureProfileClient } from './clients';
import { isDevelopEnv, isOnlyProduction, isOnlyRelease } from './platform';
import { ENV } from '../config';

export const isEmpty = (object: unknown): boolean | undefined => {
  if (Array.isArray(object)) {
    return !object.length;
  }
  if (typeof object === 'object') {
    return !Object.keys(object || {}).length;
  }
};

export const getCookie = (name: string): string => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() ?? '';
  }
  return '';
};

export const formatNumberAsUSDPrice = (number: number): string => {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(number);
};

export const redirectToUpgradeToPro = (): CallHistoryMethodAction<[string, unknown?]> => push('/settings/subscription/upgrade-to-pro');

const getEnvSuffix = () => {
  if (isDevelopEnv()) {
    return '-Dev';
  }
  if (isOnlyRelease()) {
    return '-Staging';
  }
  if (isOnlyProduction()) {
    return '';
  }
  return `-${ENV}`;
};

export const getAppTitle = (): string => {
  const envSuffix = getEnvSuffix();
  if (isPureProfileClient()) {
    return 'Datarubico' + envSuffix;
  }
  if (isNetquestClient()) {
    return 'Flash Survey' + envSuffix;
  }
  return 'SightX' + envSuffix;
};

export const parseCommaSeparatedValues = (idsString = ''): string[] => idsString.split(',').filter(id => id.length > 0);
